import Galerija1 from './assets/img/galleryCatering/restoran-dubrovnik-catering-1.webp'
import Galerija2 from './assets/img/galleryCatering/restoran-dubrovnik-catering-2.webp'
import Galerija3 from './assets/img/galleryCatering/restoran-dubrovnik-catering-3.webp'
import Galerija4 from './assets/img/galleryCatering/restoran-dubrovnik-catering-4.webp'
import Galerija5 from './assets/img/galleryCatering/restoran-dubrovnik-catering-5.webp'
import Galerija6 from './assets/img/galleryCatering/restoran-dubrovnik-catering-6.webp'
import Galerija7 from './assets/img/galleryCatering/restoran-dubrovnik-catering-7.webp'
import Galerija8 from './assets/img/galleryCatering/restoran-dubrovnik-catering-8.webp'
import Galerija9 from './assets/img/galleryCatering/restoran-dubrovnik-catering-9.webp'
import Galerija10 from './assets/img/galleryCatering/restoran-dubrovnik-catering-10.webp'
import Galerija11 from './assets/img/galleryCatering/restoran-dubrovnik-catering-11.webp'
import Galerija12 from './assets/img/galleryCatering/restoran-dubrovnik-catering-12.webp'
import Galerija13 from './assets/img/galleryCatering/restoran-dubrovnik-catering-13.webp'
import Galerija14 from './assets/img/galleryCatering/restoran-dubrovnik-catering-14.webp'
import Galerija15 from './assets/img/galleryCatering/restoran-dubrovnik-catering-15.webp'
import Galerija16 from './assets/img/galleryCatering/restoran-dubrovnik-catering-16.webp'


export const slikeCatering = [
    {
      src: Galerija1,
      title: 'Restaurant Dubrovnik Catering, Weddings',
      description: 'Restaurant Dubrovnik Catering, Weddings',
    },
    {
      src: Galerija2,
      title: 'Restaurant Dubrovnik Catering, Weddings',
      description: 'Restaurant Dubrovnik Catering, Weddings',
    },
    {
      src: Galerija3,
      title: 'Restaurant Dubrovnik Catering, Weddings',
      description: 'Restaurant Dubrovnik Catering, Weddings',
    },
    {
      src: Galerija4,
      title: 'Restaurant Dubrovnik Catering, Weddings',
      description: 'Restaurant Dubrovnik Catering, Weddings',
    },
    {
      src: Galerija5,
      title: 'Restaurant Dubrovnik Catering, Weddings',
      description: 'Restaurant Dubrovnik Catering, Weddings',
    },
    {
      src: Galerija6,
      title: 'Restaurant Dubrovnik Catering, Weddings',
      description: 'Restaurant Dubrovnik Catering, Weddings',
    },
    {
      src: Galerija7,
      title: 'Restaurant Dubrovnik Catering, Weddings',
      description: 'Restaurant Dubrovnik Catering, Weddings',
    },
    {
      src: Galerija8,
      title: 'Restaurant Dubrovnik Catering, Weddings',
      description: 'Restaurant Dubrovnik Catering, Weddings',
    },
    {
      src: Galerija9,
      title: 'Restaurant Dubrovnik Catering, Weddings',
      description: 'Restaurant Dubrovnik Catering, Weddings',
    },
    {
      src: Galerija10,
      title: 'Restaurant Dubrovnik Catering, Weddings',
      description: 'Restaurant Dubrovnik Catering, Weddings',
    },
    {
      src: Galerija11,
      title: 'Restaurant Dubrovnik Catering, Weddings',
      description: 'Restaurant Dubrovnik Catering, Weddings',
    },
    {
      src: Galerija12,
      title: 'Restaurant Dubrovnik Catering, Weddings',
      description: 'Restaurant Dubrovnik Catering, Weddings',
    },
    {
      src: Galerija13,
      title: 'Restaurant Dubrovnik Catering, Weddings',
      description: 'Restaurant Dubrovnik Catering, Weddings',
    },
    {
      src: Galerija14,
      title: 'Restaurant Dubrovnik Catering, Weddings',
      description: 'Restaurant Dubrovnik Catering, Weddings',
    },
    {
      src: Galerija15,
      title: 'Restaurant Dubrovnik Catering, Weddings',
      description: 'Restaurant Dubrovnik Catering, Weddings',
    },
    {
      src: Galerija16,
      title: 'Restaurant Dubrovnik Catering, Weddings',
      description: 'Restaurant Dubrovnik Catering, Weddings',
    },
  ]